import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";
import {
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import Select from "react-select";
import ButtonCustom from "../../components/Buttons/ButtomCustom";
import {
  cleanMessageUser,
  getUser,
  getUserRoles,
  loadEmptyUser,
  saveUser,
} from "../../store/actions";
import { useEffect } from "react";
import useQueryParams from "../../customHooks/useQueryParams";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { Controller, useForm } from "react-hook-form";
import { setValuesHookForm } from "../../helpers/load_object_hook_form";
import { fieldsMessage } from "../../helpers/utils/fieldsMessage";
import "../../assets/scss/_commomAdminPages.scss";
import { useNavigate } from "react-router-dom";
import ActionButtons from "../../components/ActionButtons/ActionButtons";
import { useContextActions } from "../../customHooks/useContextActions";
import './style.scss';

const UserDetail = ({
  saveUserRequest,
  getUserRequest,
  cleanMessageUser,
  isUserSave,
  user,
  loadingUser,
  messageUser,
  errorLoadingUser,
  getUserRolesRequest,
}) => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      active: true,
    }
  });

  const alertModal = withReactContent(Swal);
  const navigate = useNavigate();
  const query = useQueryParams();
  const id = query.get("id");

  const handleSave = (values) => {
    if (id === null) {
      saveUserRequest({
        body: {
          record: { email: values.email, active: values.active },
          roles: values.permissions.map((x) => x.label),
        },
        type: "POST",
      });
    } else {
      saveUserRequest({
        body: {
          record: { email: values.email, active: values.active, id: id },
          roles: values.permissions.map((x) => x.label),
        },
        type: "PUT",
      });
    }
  };
  const handleBack = () => {
    loadEmptyUser();
    navigate("/users");
  };

  const actions = useContextActions({
    context: "user",
    screen: "detail",
  });
	const editableWithSave = actions.some(e => e === "save")

  useEffect(() => {
    if (id !== null) {
      getUserRequest({ userId: id });
    }

    return () => {
      cleanMessageUser();
      loadEmptyUser();
    };
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (isUserSave !== null) {
      alertModal
        .fire({
          title:
            isUserSave === true
              ? `User ${id === null ? "created" : "updated"} successfully`
              : `${
                  messageUser !== null
                    ? messageUser
                    : "Something wrong, try again later."
                }`,
          icon: isUserSave === true ? "success" : "error",
          showConfirmButton: false,
          timer: isUserSave === true ? 2000 : undefined,
          showCloseButton: !isUserSave,
          timerProgressBar: isUserSave === true ? true : false,
        })
        .then((result) => {
          getUserRolesRequest();
          cleanMessageUser();
          if (isUserSave) navigate("/users");
        });
    }

    // eslint-disable-next-line
  }, [isUserSave]);
  useEffect(() => {
    if (errorLoadingUser !== null) {
      alertModal
        .fire({
          title: "Something wrong, try again later.",
          icon: "error",
          showConfirmButton: false,
          showCloseButton: true,
          allowOutsideClick: false,
          //timer: 2000,
          //timerProgressBar: true,
        }).then((result) => {
          if (errorLoadingUser) {
            if (result.dismiss) {
              cleanMessageUser();
              loadEmptyUser();
              navigate("/users");
            }
          }
          if (result.dismiss) {
            cleanMessageUser();
            loadEmptyUser();
          }
        })
    }

    // eslint-disable-next-line
  }, [errorLoadingUser]);
  useEffect(() => {
    if (!user) return;

    const { record, roles } = user;

    var oldRoles = [];
    roles.forEach((item) => {
      oldRoles.push(optionsPermissions.find((x) => x.label === item));
    });

    setValuesHookForm({ ...record, permissions: oldRoles }, setValue);
    setValue("active", user.record.active ?? true)

    // eslint-disable-next-line
  }, [user]);

  return (
    <div className="page-content">
      <Helmet>
        <title>User</title>
      </Helmet>
      <Container fluid className="user__container-fluid">
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <div>
                  <Row className="my-2">
                    {loadingUser ? (
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ height: "400px", width: "100%" }}
                      >
                        <Spinner
                          color="primary"
                          style={{ height: "5rem", width: "5rem" }}
                        />
                      </div>
                    ) : (
                      <>
                        <form onSubmit={handleSubmit(handleSave)}>
                          <div className="d-flex justify-content-between my-2">
                            <h2>{id === null ? "CREATE" : "EDIT"} USER</h2>
                            <div className="d-flex gap-2 mb-4">
                              <ButtonCustom
                                type="cancel"
                                onClick={() => handleBack()}
                              />
                              <ActionButtons 
                                actions={actions}
                                handlers={{
                                  save: handleSubmit(handleSave),
                                }}
                              />
                            </div>
                          </div>
                          <Row>
                            <Col md="4">
                              <FormGroup className="mb-3">
                                <Label
                                  htmlFor="email"
                                  className="label-detail-form"
                                >
                                  Email
                                </Label>
                                <input
                                  className="form-control"
                                  id="email"
                                  type="text"
                                  disabled={!editableWithSave}
																	style={!editableWithSave ? {color: "#00000060"} : {}}
                                  {...register("email", {
                                    required:
                                      fieldsMessage.required("User email"),
                                    validate: {
                                      notEmpty: (value) =>
                                        value.trim() !== "" ||
                                        fieldsMessage.required("User email"),

                                      isEmail: (value) =>
                                        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                                          value
                                        ) ||
                                        fieldsMessage.invalidFormat(
                                          "User email"
                                        ),
                                    },
                                    maxLength: {
                                      value: 200,
                                      message: fieldsMessage.maxLength(
                                        "User email",
                                        200
                                      ),
                                    },
                                  })}
                                />
                                <p className="error-form">
                                  {errors.email?.message}
                                </p>
                              </FormGroup>
                            </Col>
                            <Col md="2">
                              <FormGroup className="mb-3">
                                <Label
                                  htmlFor="createUser"
                                  className="label-detail-form"
                                >
                                  Created By
                                </Label>
                                <input
                                  className="form-control"
                                  id="createUser"
                                  {...register("createUser")}
                                  disabled
                                  style={{ color: '#00000060'}}
                                />
                              </FormGroup>
                            </Col>
                            <Col md="2">
                              <FormGroup className="mb-3">
                                <Label
                                  id="createDate"
                                  className="label-detail-form"
                                >
                                  Creation Date
                                </Label>
                                <input
                                  className="form-control"
                                  name="createDate"
                                  {...register("createDate")}
                                  disabled
                                  style={{ color: '#00000060'}}
                                />
                              </FormGroup>
                            </Col>
                            <Col md="2">
                              <FormGroup className="mb-3">
                                <Label
                                  id="updateUser"
                                  className="label-detail-form"
                                >
                                  Updated By
                                </Label>
                                <input
                                  className="form-control"
                                  name="updateUser"
                                  {...register("updateUser")}
                                  disabled
                                  style={{ color: '#00000060'}}
                                />
                              </FormGroup>
                            </Col>
                            <Col md="2">
                              <FormGroup className="mb-3">
                                <Label
                                  id="updateDate"
                                  className="label-detail-form"
                                >
                                  Update Date
                                </Label>
                                <input
                                  className="form-control"
                                  name="updateDate"
                                  {...register("updateDate")}
                                  disabled
                                  style={{ color: '#00000060'}}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row className="my-2 mb-5">
                            <Col md="4">
                              <Label className="label-detail-form">
                                Permissions
                              </Label>
                              <Controller
                                id="permissions"
                                name="permissions"
                                control={control}
                                rules={{
                                  required: "Permissions is required",
                                }}
                                render={({ field }) => (
                                  <Select
                                    {...field}
                                    className={`filter-select`}
                                    options={optionsPermissions}
                                    isMulti
                                    onChange={(selected) =>
                                      field.onChange(selected)
                                    }
                                    value={field.value}
                                    placeholder="Select Permissions"
                                    isClearable={true}
                                    isDisabled={!editableWithSave}
                                  />
                                )}
                              />
                              {errors && (
                                <p className="error-form">
                                  {errors.permissions?.message}
                                </p>
                              )}
                            </Col>
                            <Col>
                              <FormGroup>
                                <label htmlFor="active" className="label-check">
                                  <input
                                    id="active"
                                    type="checkbox"
                                    className="form-check-input"
                                    {...register("active")}
                                    disabled={!editableWithSave}
                                  />
                                  Active Status
                                </label>
                              </FormGroup>
                            </Col>
                          </Row>
                        </form>
                      </>
                    )}
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const mapStateToProps = ({
  UserReducer: {
    loadingUser,
    listaUser,
    dropdownUser,
    user,
    messageUser,
    isUserSave,
    errorLoadingUser
  },
}) => ({
  loadingUser,
  listaUser,
  dropdownUser,
  user,
  messageUser,
  isUserSave,
  errorLoadingUser
});

const mapDispatchToProps = {
  saveUserRequest: saveUser.request,
  getUserRequest: getUser.request,
  getUserRolesRequest: getUserRoles.request,
  loadEmptyUser,
  cleanMessageUser,
};

const optionsPermissions = [
  { value: 1, label: "Admin" },
  { value: 2, label: "Author" },
  { value: 3, label: "Publisher" },
  { value: 4, label: "Reviewer" },
  { value: 5, label: "BulkSubmitter" },
  { value: 6, label: "BulkReviewer" },
  { value: 7, label: "BulkPublisher" },
  { value: 8, label: "BulkObsoleter" },
];

export default connect(mapStateToProps, mapDispatchToProps)(UserDetail);
